// --- Our Modules --------------------------------------------------------------------------------
import ar from "./ar";
import en from "./en";
// --- Logic --------------------------------------------------------------------------------------
export default { ar, en };
